import { render, staticRenderFns } from "./addlecturer.vue?vue&type=template&id=7a385f9c&scoped=true&"
import script from "./addlecturer.vue?vue&type=script&lang=js&"
export * from "./addlecturer.vue?vue&type=script&lang=js&"
import style0 from "./addlecturer.vue?vue&type=style&index=0&id=7a385f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a385f9c",
  null
  
)

export default component.exports